class BarBlockService {
  getLabels (strataDefinition, stratifyBy) {
    if (strataDefinition && Array.isArray(strataDefinition.options) && stratifyBy) {
      const currentStrata = strataDefinition.options.find((option) => (option.value === stratifyBy))
      if (currentStrata && Array.isArray(currentStrata.legend)) {
        return currentStrata.legend
      }
    }
  }

  transformToTableData (data, dataDefinition = {}, selections = {}, { columnsToHide = {}, labels = [] }) {
    const rowField = dataDefinition.xField
    const columnField = (selections.strata === undefined) ? dataDefinition.groupField : selections.strata?.value
    const labelsHash = labels.reduce((labelsHash, { value, label }) => {
      labelsHash[value] = label
      return labelsHash
    }, {})
    return data
      .map((d) => {
        let column = (columnField === dataDefinition.emptyValue || d[columnField] === undefined) ? 'Overall' : d[columnField]
        if (labelsHash[column]) {
          column = labelsHash[column]
        }
        const dataPoint = {
          row: d[rowField].toString(),
          column,
          ...d
        }
        return dataPoint
      })
      .filter((d) => (!columnsToHide[d.column]))
  }

  calculateBounds (chartDatasets, dataField, legendToggles) {
    const result = { min: 0 }
    chartDatasets.forEach(({ data, groupField }) => {
      data.forEach((p) => {
        const series = p[groupField]
        const isSeriesOff = legendToggles[series] === true
        if (isSeriesOff || !dataField) {
          return
        }
        // Handle bar chart values that are strings
        // null values are transformed to undefined so they result in NaN and are ignored
        const value = Number(p[dataField] ?? undefined)
        if (isNaN(value)) {
          return
        }
        if (result.min === undefined || value < result.min) {
          result.min = value
        }
        if (result.max === undefined || value > result.max) {
          result.max = value
        }
      })
    })

    return result
  }
}

export const barBlockService = new BarBlockService()
